module.exports = __webpack_public_path__ + "img/chat-file-message-download.d5e329e3.svg";